import { combineLatest, defer, map } from 'rxjs';
import { link } from 'services/navigation';
import authorization from 'services/authorization';
import type { NavigationMenuItem } from 'contracts';
import legacyId from 'pages/redirection/legacy/@@global/id';
import performerProfilePictures from 'store/performer-profile-pictures';
import performer from 'store/performer';

import messages from '../profile-photo.i18n';

import id from './id';

const menu: NavigationMenuItem = {
  entries: [
    {
      name: id,
      label: messages.pages.profile.profilePhoto.navigationMenu.label,
      link: () => link[id](),
      visibility$: authorization.getAuthorization$(id),
      notification$: defer(() =>
        combineLatest([performerProfilePictures.onChange$, performer.onStatusChange$]).pipe(
          map(() => {
            const hasPictures = performerProfilePictures.hasPictures();
            const isMissingCrop = hasPictures && !performerProfilePictures.hasSelectedPicturePortraitCrop();
            const isMissingPictures = !hasPictures && !performer.hasClosedStatus();

            return isMissingCrop || isMissingPictures ? -1 : 0;
          })
        )
      ),
      parent: legacyId.profile,
      weight: 1,
    },
  ],
  activates: {
    [id]: [id],
  },
};

export default menu;
